import { render, staticRenderFns } from "./BalaAssignadaDetail.vue?vue&type=template&id=8b93661a&scoped=true"
import script from "./BalaAssignadaDetail.vue?vue&type=script&lang=js"
export * from "./BalaAssignadaDetail.vue?vue&type=script&lang=js"
import style0 from "./BalaAssignadaDetail.vue?vue&type=style&index=0&id=8b93661a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b93661a",
  null
  
)

export default component.exports